
define(
	'NetScore.CartErrMessage.CartErrMessage'
,   [
		'NetScore.CartErrMessage.CartErrMessage.View'
	,	'Cart.Detailed.View'
	,	'GlobalViews.Message.View'
	,	'LiveOrder.Model'
	,	'SC.Configuration'
	,   'Utils'
	,   'Cart.Item.Summary.View'
	,	'Profile.Model'
	//,    'OrderWizard.Module.CartSummary'
	]
,   function (
		CartErrMessageView
	, 	CartDetailedView
	, 	GlobalViewsMessageView
	,	LiveOrderModel
	,	Configuration
	,   Utils
	,   CartItemSummaryView
	,	ProfileModel 
	//,    OrderWizardModuleCartSummary
	)
{
	'use strict';
	
	var cart ;
	return  {
		mountToApp: function mountToApp (container)
		{
			// using the 'Layout' component we add a new child view inside the 'Header' existing view 
			// (there will be a DOM element with the HTML attribute data-view="Header.Logo")
			// more documentation of the Extensibility API in
			// https://system.netsuite.com/help/helpcenter/en_US/APIs/SuiteCommerce/Extensibility/Frontend/index.html
			
			/** @type {LayoutComponent} */
			var layout = container.getComponent('Layout');
			 if(layout)
            {
          
            }
			
			cart = container.getComponent("Cart");
					// console.log("cart",cart);
				if(cart)
             	{
                cart.addChildViews(
                    'Cart.Detailed.View'
                ,    {
                        'Item.Summary.View': {
                           'NetScore.CartErrMessage.CartErrMessage.View' : {
                                childViewIndex: 3
                            ,    childViewConstructor: function()
                                {
                                    return new CartErrMessageView({
                                        cart: cart
                                    });
                                }
                            }
                        }
                    }
                );
            }

       CartDetailedView.prototype.updateItemQuantity = function (e)
		 
		{
			 // console.log("CartDetailedView updateItemQuantity");			
			var livemodel=LiveOrderModel.getInstance();
                 // console.log('model234',livemodel); 
				var lineId=livemodel.attributes.latest_addition;
				// console.log("lineId",lineId);			
					// console.log("item_details",item_details);
			
			var self = this
			,	$line = null
			,	$form = jQuery(e.target).closest('form')
			,	options = $form.serializeObject()
			,	internalid = options.internalid
			,	line = this.model.get('lines').get(internalid)
			,	$input = $form.find('[name="quantity"]')
			,	validInput = this.validInputValue($input[0]);
			 // console.log("internalid",internalid);
				var item_details=_.find(livemodel.get('lines').models, function(value){
                       // return value.id ==lineId;
						 return value.id ==internalid;
                   })
			// console.log("item_details",item_details);
       var available_quantity=item_details.attributes.item.attributes.quantityavailable;
         // var available_quantity=58;
		 // console.log("available_quantity",available_quantity);
		 var max_order_amnt =item_details.attributes.item.attributes.maximumquantity;
		  // console.log("max_order_amnt",max_order_amnt);
			if (!line || this.isRemoving)
			{
				return;
			}

			if (!validInput || options.quantity)
			{
				var	new_quantity = parseInt(options.quantity, 10)
				,	item = line.get('item')
				,	min_quantity = item ? item.get('_minimumQuantity', true) : line.get('minimumquantity')
				,	current_quantity = parseInt(line.get('quantity'), 10)
			  // ,	available_quantity = item ? item.get('_quantityavailable', true) : line.get('quantityavailable');
                
				new_quantity = (new_quantity >= min_quantity) ? new_quantity : current_quantity;

				$input.val(new_quantity);
				// console.log("item",item);
				// console.log("line",line);
                // console.log("min_quantity",min_quantity);
				// console.log("current_quantity",current_quantity);
				///console.log("available_quantity",available_quantity);
				// console.log("new_quantity",new_quantity);
               var liveorder=LiveOrderModel.getInstance().get('lines');
			   // console.log("liveorder",liveorder);
			 
			
			  
			 
				
				if (new_quantity !==  current_quantity)
				{
        
					$line = this.$('#' + internalid);
					$input.val(new_quantity).prop('disabled', true);
					line.set('quantity', new_quantity);

					var invalid = line.validate();

					if (!invalid)
					{
						if(max_order_amnt==undefined)
						{
						if(available_quantity && (new_quantity > available_quantity) ){
							// console.log("sa");
								var placeholder = this.$('#' + internalid + ' [data-type="alert-placeholder"]');
								placeholder.empty();
                                //var configure_err_message="You can order a maximum of | pieces.";
								// var configure_err_message="We only have | pieces of  remaining. You can order maximum | pieces.";
                                 var configure_err_message=SC.CONFIGURATION.CartErrMessage.CartErrorMessage;
                                 //console.log("configure_err_message",configure_err_message);
                                 var err_msg_split=configure_err_message.split('|');
                                 // console.log("err_msg_split",err_msg_split);
                                 var msg_part=err_msg_split.length;
                                 // console.log("msg_part",msg_part);
                                 var dynamic_err_message=err_msg_split[0] +   + available_quantity + err_msg_split[1];
                            	 // console.log("dynamic_err_message",dynamic_err_message);
								// var errmsg = _('The number of available quantity of this item is   $(0)').translate(available_quantity);
								var global_view_message = new GlobalViewsMessageView({
										message: dynamic_err_message
									,	type: 'error'
									// ,	closable: true
								});
								global_view_message.show(placeholder, 50000);

								$input.prop('disabled', false);
								
								$input.val(available_quantity);
								$input.focus();
							//line.set('quantity', available_quantity);
							cart.updateLine({
	                               line: {
		                          internalid: internalid,
	                 	            quantity: available_quantity
	                         }
                              })
						}
						else 

						var update_promise = this.model.updateLine(line);

						this.disableElementsOnPromise(update_promise, '#' + internalid + ' button');

						update_promise.fail(function (jqXhr)
						{
							jqXhr.preventDefault = true;
							var result = JSON.parse(jqXhr.responseText);

							self.showError(result.errorMessage, $line, result.errorDetails);
							line.set('quantity', current_quantity);
						}).always(function ()
						{
							$input.prop('disabled', false);
						});
					}
					else
					   {
						  if(available_quantity && (new_quantity > available_quantity) ){
							   if(max_order_amnt>available_quantity ){
							// console.log("samb");
								var placeholder = this.$('#' + internalid + ' [data-type="alert-placeholder"]');
								placeholder.empty();
                                //var configure_err_message="You can order a maximum of | pieces.";
								 // var configure_err_message="We only have | pieces of  remaining. You can order maximum | pieces.";
                                 var configure_err_message=SC.CONFIGURATION.CartErrMessage.CartErrorMessage;
                                 // console.log("configure_err_message",configure_err_message);
                                 var err_msg_split=configure_err_message.split('|');
                                 // console.log("err_msg_split",err_msg_split);
                                 var msg_part=err_msg_split.length;
                                 // console.log("msg_part",msg_part);
                                 var dynamic_err_message=err_msg_split[0] +   + available_quantity + err_msg_split[1];
                            	 // console.log("dynamic_err_message",dynamic_err_message);
								// var errmsg = _('The number of available quantity of this item is   $(0)').translate(available_quantity);
								var global_view_message = new GlobalViewsMessageView({
										message: dynamic_err_message
									,	type: 'error'
									// ,	closable: true
								});
								global_view_message.show(placeholder, 50000);

								$input.prop('disabled', false);
								
								$input.val(available_quantity);
								//line.set('quantity', available_quantity);
								cart.updateLine({
	                               line: {
		                          internalid: internalid,
	                 	            quantity: available_quantity
	                         }
                              })
								$input.focus();
							
						}
						else {
								var placeholder = this.$('#' + internalid + ' [data-type="alert-placeholder"]');
								placeholder.empty();
                               // var configure_err_message="You can order a maximum of | pieces.";
								 // var configure_err_message="We only have | pieces of  remaining. You can order maximum | pieces.";
                                 var configure_err_message=SC.CONFIGURATION.CartErrMessage.CartErrorMessage;
                                 // console.log("configure_err_message",configure_err_message);
                                 var err_msg_split=configure_err_message.split('|');
                                 // console.log("err_msg_split",err_msg_split);
                                 var msg_part=err_msg_split.length;
                                 // console.log("msg_part",msg_part);
                                 var dynamic_err_message=err_msg_split[0] +   + max_order_amnt + err_msg_split[1];
                            	 // console.log("dynamic_err_message",dynamic_err_message);
								// var errmsg = _('The number of available quantity of this item is   $(0)').translate(available_quantity);
								var global_view_message = new GlobalViewsMessageView({
										message: dynamic_err_message
									,	type: 'error'
									// ,	closable: true
								});
								global_view_message.show(placeholder, 50000);

								$input.prop('disabled', false);
								
								$input.val(max_order_amnt);
								//line.set('quantity', max_order_amnt);
								cart.updateLine({
	                               line: {
		                          internalid: internalid,
	                 	            quantity: max_order_amnt
	                         }
                              })
								$input.focus();
						   }
						}
						else if(max_order_amnt && (new_quantity > max_order_amnt) ){
								var placeholder = this.$('#' + internalid + ' [data-type="alert-placeholder"]');
								placeholder.empty();
                               //var configure_err_message="You can order a maximum of | pieces.";
								 // var configure_err_message="We only have | pieces of  remaining. You can order maximum | pieces.";
                                 var configure_err_message=SC.CONFIGURATION.CartErrMessage.CartErrorMessage;
                                 // console.log("configure_err_message",configure_err_message);
                                 var err_msg_split=configure_err_message.split('|');
                                 // console.log("err_msg_split",err_msg_split);
                                 var msg_part=err_msg_split.length;
                                 // console.log("msg_part",msg_part);
                                 var dynamic_err_message=err_msg_split[0] +   + max_order_amnt + err_msg_split[1];
                            	 // console.log("dynamic_err_message",dynamic_err_message);
								// var errmsg = _('The number of available quantity of this item is   $(0)').translate(available_quantity);
								var global_view_message = new GlobalViewsMessageView({
										message: dynamic_err_message
									,	type: 'error'
									// ,	closable: true
								});
								global_view_message.show(placeholder, 50000);

								$input.prop('disabled', false);
								
								$input.val(max_order_amnt);
								
							//line.set('quantity', max_order_amnt);
			               cart.updateLine({
	                               line: {
		                          internalid: internalid,
	                 	            quantity: max_order_amnt
	                         }
                              })
							  $input.focus();
						}
						else 

						var update_promise = this.model.updateLine(line);

						this.disableElementsOnPromise(update_promise, '#' + internalid + ' button');

						update_promise.fail(function (jqXhr)
						{
							jqXhr.preventDefault = true;
							var result = JSON.parse(jqXhr.responseText);

							self.showError(result.errorMessage, $line, result.errorDetails);
							line.set('quantity', current_quantity);
						}).always(function ()
						{
							$input.prop('disabled', false);
						});   
					   }
					}
					else
					{
						var placeholder = this.$('#' + internalid + ' [data-type="alert-placeholder"]');
						placeholder.empty();

						_.each(invalid, function(value)
						{
							var global_view_message = new GlobalViewsMessageView({
									message: value
								,	type: 'error'
								// ,	closable: true
							});

							placeholder.append(global_view_message.render().$el.html());
						});

						$input.prop('disabled', false);
						//line.set('quantity', current_quantity);
					}
				}
			}
		}
 	CartDetailedView.prototype.getContext = function(e) 
 	{	  
       var livemodel=LiveOrderModel.getInstance();
	   // console.log("livemodel",livemodel);
	   var model=this.model;
	   // console.log("model",model);
	   var lines=LiveOrderModel.getInstance().get('lines');
	     // console.log("lines", lines);
	   var length = lines.length;
       // console.log("length", length);
	    var count = 0;
	   //var quantity_available = 42;
	  // var max_qty= 1;
	    for (var i = 0; i < length; i++) {
	         var quantity_available=lines.models[i].attributes.item.attributes.quantityavailable;	
	       // quantity_available=quantity_available+i;
		   //max_qty=max_qty+i;
	       var int_id = lines.models[i].attributes.internalid;
	      // console.log("int_id", int_id);
		 // console.log("quantity_available",quantity_available);
		 var max_qty= lines.models[i].attributes.item.attributes.maximumquantity;
		//var max_qty= 8;
		 //console.log("max_qty",max_qty);
	      if(int_id)
	        {
	        	var quantity_ordered=lines.models[i].attributes.quantity;
	      //	console.log("quantity_ordered",quantity_ordered);
	       	var j_id = "quantity-" + int_id;
	        //	console.log("j_id", j_id);

	     if(max_qty==undefined)
		    {
	       if (quantity_ordered > quantity_available) {
	            count = count + 1;
	            var status = true;
	             // console.log("status", status);
	             var line = livemodel.get('lines').get(int_id);
	           // console.log("line", line)
	             if (status == true) {
	                 //var dynamic_err_message = "We only have " + quantity_available + " pieces available.";
	                 $('#error-' + int_id).html('test');
	               //  line.set('quantity', quantity_available);
	                   cart.updateLine({
	                               line: {
		                          internalid: int_id,
	                 	            quantity: quantity_available
	                         }
                              })
             }
	         }
			}
		else{
                 if ((quantity_ordered > quantity_available)&&(max_qty>quantity_available)) {
	            count = count + 1;
	            var status = true;
	             // console.log("status", status);
	             var line = livemodel.get('lines').get(int_id);
	           // console.log("line", line)
	             if (status == true) {
	                 //var dynamic_err_message = "We only have " + quantity_available + " pieces available.";
	                 $('#error-' + int_id).html('test');
	                 //line.set('quantity', quantity_available);
	                      cart.updateLine({
	                               line: {
		                          internalid: int_id,
	                 	            quantity: quantity_available
	                         }
                              }) 

             }
	         }
			 else if (quantity_ordered > max_qty) {
	            count = count + 1;
	            var status = true;
	             // console.log("status", status);
	             var line = livemodel.get('lines').get(int_id);
	           // console.log("line", line)
	             if (status == true) {
	                 //var dynamic_err_message = "We only have " + quantity_available + " pieces available.";
	                 $('#error-' + int_id).html('test');
	                // line.set('quantity', max_qty);
	               
                             cart.updateLine({
	                               line: {
		                          internalid: int_id,
	                 	            quantity: max_qty
	                         }
                              })
             }
	         }
	    	}			  
			
			
	        }
	       // console.log("quantity_available", quantity_available);
	     }
	     var product_count = lines.length;
	     var item_count = _.reduce(
	        lines.models,
	        function(memo, line) {
             return memo + line.get('quantity');
         },
	         0
	     );
	    var product_and_items_count = '';

	   if (product_count === 1) {
	         if (item_count === 1) {
	             product_and_items_count = Utils.translate('1 Product, 1 Item');
         } else {
             product_and_items_count = Utils.translate('1 Product, $(0) Items', item_count);
	         }
	    } else if (item_count === 1) {
	        product_and_items_count = Utils.translate('$(0) Products, 1 Item', product_count);
	    } else {
	         product_and_items_count = Utils.translate(
	           '$(0) Products, $(1) Items',
	           product_count,
	            item_count
	        );
	    }
     // @class Cart.Detailed.View.Context
	     return {
	         // @property {LiveOrder.Model} model
	         model: this.model,
	        // @property {Boolean} showLines
	       showLines: !!(lines && lines.length),
	       // @property {Orderline.Collection} lines
	       lines: lines,
	       // @property {String} productsAndItemsCount
	       productsAndItemsCount: product_and_items_count,
	       // @property {Number} productCount
	        productCount: product_count,
	       // @property {Number} itemCount
	       itemCount: item_count,
	        // @property {String} pageHeader
	       pageHeader: this.page_header,
         quantity_available: quantity_available
	  };
	 }
	 CartItemSummaryView.prototype.getContext = function(e) {
        var minimum_quantity = this.model.get('item').get('_minimumQuantity', true) || 1;
        var maximum_quantity = this.model.get('item').get('_maximumQuantity', true);
        var price_container_object = this.model.getPrice();

 

        // @class Cart.Item.Summary.View.Context
        return {
            // @property {Model} line
            line: this.model,
            // @property {String} lineId
            lineId: this.model.get('internalid'),
            // @property {Boolean} isMinusButtonDisabled
            isMinusButtonDisabled:
                this.model.get('item').get('quantity') <= minimum_quantity ||
                this.model.get('item').get('quantity') === 1,
            // @property {Boolean} isPlusButtonDisabled
            isPlusButtonDisabled:
                !!maximum_quantity && this.model.get('item').get('quantity') >= maximum_quantity,
            // @property {Boolean} showQuantity
            showQuantity: this.model.get('item').get('_itemType') === 'GiftCert',
            // @property {Boolean} showComparePrice
            showComparePrice: this.model.get('amount') > this.model.get('total'),
            // @property {Boolean} showMinimumQuantity
            showMinimumQuantity: minimum_quantity > 1,
            // @property {Integer} minimumQuantity
            minimumQuantity: minimum_quantity,
            // @property {Boolean} showMaximumQuantity
        //showMaximumQuantity: !!maximum_quantity,
            // @property {Integer} maximumQuantity
            maximumQuantity: maximum_quantity,
            // @property {Boolean} isPriceEnabled
            isPriceEnabled: !ProfileModel.getInstance().hidePrices(),
            // @property {String} totalFormatted
            totalFormatted:
                price_container_object.total_formatted || this.model.get('total_formatted') || ''
        };
        // console.log("showMaximumQuantity",showMaximumQuantity);
    }
	
/*     OrderWizardModuleCartSummary.prototype.getContext = function(e) {
		
	} */
	
	
		}
	};
});
